import React from "react";
import { TextField, MenuItem, FormControl as MuiFormControl } from "@mui/material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";

const FormControlSpacing = styled(MuiFormControl)(spacing);
const FormControl = styled(FormControlSpacing)`
  min-width: 148px;
`;

const BankAccountSelectBox = ({
  name,
  options,
  handleChange,
  value,
  disabled = false,
  enableSpecialBehavior = false,
  selectedClaimPreviewClaimStateId = null,
  ...otherProps
}) => {
  // Function to handle select changes
  const handleSelectChange = (event) => {
    const { value } = event.target;
    handleChange(value, name);
  };

  // Function to determine if the entire dropdown should be disabled
  const isDropdownDisabled = () => {
    if (enableSpecialBehavior) {
      return selectedClaimPreviewClaimStateId === 16;
    }
    return disabled;
  };

  // Function to determine if a specific option should be disabled
  const isOptionDisabled = (option) => {
    if (enableSpecialBehavior) {
      if (selectedClaimPreviewClaimStateId === 1) {
        return option.key === 4 || option.key === 16;
      } else if (selectedClaimPreviewClaimStateId === 3) {
        return option.key === 16;
      } else if (selectedClaimPreviewClaimStateId === 4) {
        return option.key === 1 || option.key === 3;
      }
    }
    return option.disabled || false;
  };

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <TextField
          select
          variant="outlined"
          label=""
          onChange={handleSelectChange}
          fullWidth
          value={value}
          disabled={isDropdownDisabled()}
          sx={{
            "& .MuiOutlinedInput-input": {
              padding: 1.0,
            },
            "& .MuiMenuItem-root.Mui-disabled": {
              opacity: 0.5,
            },
          }}
          {...otherProps}
        >
          {options.map((option) => (
            <MenuItem key={option.key} value={option.key} disabled={isOptionDisabled(option)}>
              {option.value}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    </React.Fragment>
  );
};

export default BankAccountSelectBox;
